module.exports = __webpack_public_path__ + "img/defense-2012-doctor.2d7270a1.jpg";